import React ,{useEffect}from 'react';
import ContactForm from '../contactform';
import { motion } from 'framer-motion';

const Vulnerable = () => {

    useEffect(() => {
        // Scroll to the top of the page when the component loads
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);
  return (
    <motion.div
      className="mt-20"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
    <div className="max-w-screen-xl mx-auto p-5 mt-20 sm:p-8 md:p-12 relative">
      {/* Background div with bold text */}
      <div className="bg-cyan-900 text-white text-center py-12">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold uppercase">
          Supporting Vulnerable People
        </h1>
      </div>

      {/* Content Section */}
      <div className="mx-auto mt-3 bg-white rounded-b lg:rounded-b-none lg:rounded-r flex flex-col justify-between leading-normal">
        <div>
          <p className="text-base leading-7 my-5 text-justify">
          We act for people with or without a disability who have encountered a problem with vehicles parking on a pavement and preventing their rights of access. It may be that you are pushing a pram, or a buggy, or you are visually impaired, or you are in a wheelchair. You may be an older person.

<br/><br/>There is no excuse for vehicle owners to obstruct the pavement. There are laws about this behaviour, and we are here to ensure those laws are enforced.

<br/><br/>Subject to our terms and conditions, we will act for you to ensure the strictest action is taken against the vehicle owner. Simply fill out our form, and our legal team will be in touch with you.
          </p>
        </div>
      </div>

      {/* Contact Form */}
      <div>
        <ContactForm />
      </div>
    </div></motion.div>
  );
};

export default Vulnerable;
